import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import "../App.css";
import logo from "../images/headerlogo.png";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Import icons
const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const [imageSize, setImageSize] = useState("h-8");
  const [isBlogSubmenuOpen, setIsBlogSubmenuOpen] = useState(false);

  const navLinkClass = (key) =>
    `block py-2 px-3 w-full rounded md:bg-transparent md:p-0 hover:text-[#4CAF4F] ${
      activeLink === key ? "text-[#4CAF4F] font-semibold" : "text-black"
    }`;

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = (link) => {
    window.scrollTo(0, 0);
    setActiveLink(link);
    setIsMenuOpen(false);
  };

  const handleNavigate = () => {
    window.location.href = "https://user.rikaab.com";
  };

  useEffect(() => {
    // Keep active state in sync with current route
    const pathToKey = {
      "/": "home",
      "/service": "service",
      "/About": "about",
      "/Blogs": "blogs",
      "/awards": "awards",
      "/events": "events",
      "/Support": "support",
    };
    const pathKey = pathToKey[location.pathname];
    if (pathKey && pathKey !== activeLink) {
      setActiveLink(pathKey);
    }
  }, [location.pathname, activeLink]);

  useEffect(() => {
    const handleResize = () => {
      const newSize = window.innerWidth >= 768 ? "h-8" : "h-6";
      if (newSize !== imageSize) {
        setImageSize(newSize);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [imageSize]);

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <nav className=" dark:bg-gray-900 fixed w-full z-20 top-0 left-0 border-b border-gray-200 dark:border-gray-600 mb-10 bg-white backdrop-blur-sm p-3">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 ">
          <div className="flex items-center">
            <Link to="/" onClick={handleScrollToTop}>
              <img
                src={logo}
                className={`transition-all duration-300 ${imageSize}`}
                alt="Logo"
              />
            </Link>
          </div>

          <div className="flex md:order-2 space-x-3 md:space-x-0">
            <p
              // onClick={handleNdzavigate}
              style={{ backgroundColor: "#4caf4f" }}
              className="btn-shop-now text-white bg-blue-700 hover:bg-blue-800 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-2 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Start your journey today!
              <i className="fa-solid fa-arrow-right ms-1 mt-1 fs-16"></i>
            </p>
            <button
              onClick={handleMenuToggle}
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-sticky"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className={`w-5 h-5 ${isMenuOpen ? "hidden" : ""}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
              <svg
                className={`w-5 h-5 ${isMenuOpen ? "" : "hidden"}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div
            className={`items-center justify-between ${
              isMenuOpen ? "flex" : "hidden"
            } w-full md:flex md:w-auto md:order-1`}
            id="navbar-sticky"
          >
            <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border  border-gray-100 rounded-lg md:space-x-8 md:flex-row md:mt-0 md:border-0 md:bg-transparent dark:bg-transparent md:dark:bg-transparent dark:border-gray-700 w-full md:w-auto text-white">
              <li className="w-full">
                <Link
                  to="/"
                  className={navLinkClass("home")}
                  onClick={() => handleLinkClick("home")}
                  aria-current="page"
                >
                  Home
                </Link>
              </li>
              <li className="w-full">
                <Link
                  to="/service"
                  className={navLinkClass("service")}
                  onClick={() => handleLinkClick("service")}
                  aria-current="page"
                >
                  Service
                </Link>
              </li>
              <li className="w-full">
                <Link
                  to="/About"
                  className={navLinkClass("about")}
                  onClick={() => handleLinkClick("about")}
                >
                  About
                </Link>
              </li>
              <li
                className="relative"
                onMouseEnter={() => setIsBlogSubmenuOpen(true)}
                onMouseLeave={() => setIsBlogSubmenuOpen(false)}
              >
                <div
                  className={`flex items-center space-x-1 ml-3 hover:text-[#4CAF4F] ${
                    ["blogs", "awards", "events"].includes(activeLink)
                      ? "text-[#4CAF4F] font-semibold"
                      : "text-black"
                  }`}
                >
                  <span>Media</span>
                  {isBlogSubmenuOpen ? (
                    <FaChevronUp className="text-sm" />
                  ) : (
                    <FaChevronDown className="text-sm" />
                  )}
                </div>

                {isBlogSubmenuOpen && (
                  <div className="absolute left-0  w-48 bg-white rounded-lg shadow-lg z-10">
                    <ul className="flex flex-col space-y-1 p-2">
                      <li>
                        <Link
                          to="/Blogs"
                          // className="block py-2 px-4 text-gray-700 hover:bg-gray-100 rounded"
                          className={navLinkClass("blogs")}
                          onClick={() => {
                            setIsBlogSubmenuOpen(false);
                            handleLinkClick("blogs");
                          }}
                        >
                          Blogs
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/awards"
                          // className="block py-2 px-4 text-gray-700 hover:bg-gray-100 rounded"
                          className={navLinkClass("awards")}
                          onClick={() => {
                            setIsBlogSubmenuOpen(false);
                            handleLinkClick("awards");
                          }}
                        >
                          Awards
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/events"
                          // className="block py-2 px-4 text-gray-700 hover:bg-gray-100 rounded"
                          className={navLinkClass("events")}
                          onClick={() => {
                            setIsBlogSubmenuOpen(false);
                            handleLinkClick("events");
                          }}
                        >
                          Events
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
              </li>

              <li className="w-full">
                <Link
                  to="/Support"
                  className={navLinkClass("support")}
                  onClick={() => handleLinkClick("support")}
                >
                  Support
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
